<script setup lang="ts">
const { t } = useI18n()

const auth = useAuth()

const activeCustomer = computed(() => auth?.activeCustomer.value)

const title = computed(() => t('layouts.title', [t('profile.page.title')]))

useSeoMeta({
  title,
  ogTitle: title,
})
</script>

<template>
  <div class="max-w-3xl px-4">
    <UiCard>
      <UiCardHeader>
        <UiCardTitle>{{ t('profile.page.title') }}</UiCardTitle>
        <UiCardDescription>{{ t('profile.page.description') }}</UiCardDescription>
      </UiCardHeader>

      <UiCardContent class="space-y-6">
        <UpdateCustomerForm :initial-values="activeCustomer" />

        <RequestUpdateCustomerEmailAddressForm :initial-values="{ emailAddress: activeCustomer?.emailAddress ?? '', password: '' }" />
      </UiCardContent>
    </UiCard>
  </div>
</template>
